<template>
  <el-row class="tb">
    <el-col :span="7" style="height: 100%;display: flex;align-items: center">
<!--        <img src="../assets/basic/tbbt.png" style="margin-left: 4%" >-->
        <img src="@/assets/basic/tbbt.svg" >

        <div style="margin-left: 1%;height:5rem ;border-left: 2px solid #f9f9ff"></div>

        <el-dropdown style="padding-left: 1%"  @command="handleCommand" v-if="$route.path.substring(0,7) !== '/system'">

            <el-button style="height: 4.5rem;padding: 5px 3px;font-size: 18px;background-color: #f7eade;border-radius: 4px;border: solid 1px #af7338;color: #143D6E;">
                <div style="display: inline-block;vertical-align: middle;"><img src="@/assets/basic/sktb.png" class="el-icon--right"></div>
                <div style="display: inline-block;padding-left: 5px"> {{ skName.length > 6 ? skName.slice(0,2)+".."+skName.slice(-2) : skName}}</div>
                <div style="display: inline-block;vertical-align: middle;"> <img src="@/assets/basic/sktb2.png" ></div>
<!--                <i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
            </el-button>
            <el-dropdown-menu slot="dropdown">

                <el-dropdown-item  v-for="(item, index) in skList"  :key="item.resCd" :command="item">{{item.resName}}</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
    </el-col>
      <el-col :span="13" style="height: 100%;">
          <div class="menuSt">
              <div v-for="(item, index) in btnList"
                   :class="item.hasCheck ? 'btn-container-checked' : ''"
                   :key="index"
                   @click="handleBtnClick(index,item)" >
                  <div v-if="index < 7" class="tbdh" >
                      <div style="margin-right: 10px;margin-top: 5.5px">
                          <img :src="require('../assets/basic/'+item.iconpath+'.png')">
                      </div>
                      <div >
                          {{ item.label }}
                      </div>
                  </div>
              </div>
              <!--超过七个模块显示更多-->
              <div  class="tbdh" v-if="btnList.length >= 8">
                  <div style="margin-right: 10px;margin-top: 5.5px">
                      <img src="../assets/basic/gd.png">
                  </div>
                  <el-dropdown style="padding-left: 3%"  @command="" >
                      <span class="el-dropdown-link">
                        更多<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                      <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item  v-for="item,index in btnList"  :key="index+'gd'" :command="item">
                              <div v-if="index>=7" @click="handleBtnClick(index,item)">
                                  {{item.label}}
                                </div>
                          </el-dropdown-item>
                      </el-dropdown-menu>
                  </el-dropdown>
              </div>
          </div>
      </el-col>
      <el-col  :span="4" style="height: 100%;display: flex;align-items: center;justify-content: flex-end;padding-right: 1rem">
          <div style="font-size: 14px;color: #fff;padding-right: 20px;">{{nowDateTime}}</div>
          <div style="cursor: pointer">
              <el-dropdown mode="horizontal" @command="handleSelect">
                  <div >
                      <i class="el-icon-user"/>
                      {{data.name.length > 6 ? data.name.slice(0,2)+".."+data.name.slice(-2) : data.name}}
                      <i class="el-icon-arrow-down"></i>
                  </div>
                  <el-dropdown-menu slot="dropdown">
                     <el-dropdown-item command="1">
                          <span>个人信息</span>
                      </el-dropdown-item>
                      <el-dropdown-item command="2">
                          <span>退出</span>
                      </el-dropdown-item>
                  </el-dropdown-menu>
              </el-dropdown>
          </div>
        </el-col>
      <userOpen :dialog="dialog" @reset="reset"/>
  </el-row>
</template>

<script>

    import AES from '@/utils/decrypt'
    import userOpen from '@/views/system/open/userOpen'
    import router, {resetRouter, setRoutes} from "@/router";
    import store from "@/store";
export default {
    name: "Header",
    components:{
        userOpen
    },
    data(){
      return{
         /* data:localStorage.getItem("token") ?
              decrypt(JSON.parse(localStorage.getItem("token")),'b58bb6e24da62b01ba6645b2047e86258af4c8391f13f0f11ffff43da9751b5b') : {},*/
         data:{
             name:'2',
         },
          dialog:{
              title:"",
              formVisible:false,
              data:{}
          },
          clientHeight:document.documentElement.clientHeight,
          skList:{
              resCd:'',
              resName:'',
          },
          skName:localStorage.getItem("skName") ? localStorage.getItem("skName") : "",
          btnList: localStorage.getItem("menus") ? JSON.parse(localStorage.getItem("menus")) : [],
          nowDateTime:'',
          timer: '',
      }
    },
    methods: {
        logOut(){
            this.request.get("/rm-suser/v1/logout").then(res => {
              if(res.ok){
                  //清除tag栏
                  this.$store.commit('RESET_STATE');
                  localStorage.clear();
                this.$store.commit('RESET','');
                this.$router.replace('/login');

                  // 重置路由
                  resetRouter()
              }
            })
        },
        //token解密
        decrypt1(){
           this.data = JSON.parse(AES.decrypt(localStorage.getItem("token")));
           localStorage.setItem("userid",this.data.id);
        },
        setUser(title){
            if(this.data){
                this.request.get("/rm-suser/v1/"+this.data.id, {params: this.data.id}).then(res => {
                    if (res.ok) {
                        this.dialog.data = res.data
                    }
                })
                this.dialog.title = title
                this.dialog.formVisible = true
            }
        },
        // 表单重置
        reset() {
            this.dialog.data = {}
        },
        //获取登录用户信息
        getUserInfo(){
            this.request.get("/rm-suser/v1/loginUser",{}).then(res=>{
                if(res.ok){
                    if(res.data.resList!==null && res.data.resList.length > 0){
                        for(let item of  res.data.resList){
                            if(item.resName.length > 6){
                                item.resName = item.resName.slice(0,2)+".."+item.resName.slice(-2)
                            }
                        }
                        this.skList = res.data.resList
                    }

                }
            })
        },
        //切换水库
        handleCommand(command){
            this.skName = command.resName
            //localStorage.setItem("skName", command.resName)
            this.$store.commit("SETSKCD", command.rescd)
            this.$store.commit("SETSKNAME", command.resName)
            //localStorage.setItem("skCd", command.rescd)
        },
        handleBtnClick(index,item) {
            if(index === this.$route.meta.check){
                return
            }
            this.btnList.forEach((item) => {
                item.hasCheck = false;
            });
            this.btnList[index].hasCheck = true;
            //this.setCheck(index);
            let route = null;
            let label = null;
            if(item.leaf){
                route = item.route
                label = item.label
                this.$store.commit('selectMenu', item);
            }else{
                route = item.children[0].route
                label = item.children[0].label
                this.$store.commit('selectMenu', item.children[0]);
            }

            this.$router.push({
                name:route,
                params:{
                    label:label,
                    check:index
                }
            })
        },
        dateNumber () {
            let today = new Date()
            let date = today.getFullYear() + '-' + this.twoDigits(today.getMonth() + 1) + '-' + this.twoDigits(today.getDate())
            return date
        },
        timeNumber () {
            let today = new Date()
            let time = this.twoDigits(today.getHours()) + ':' + this.twoDigits(today.getMinutes()) + ':' + this.twoDigits(today.getSeconds())
            return time
        },
        twoDigits (val) {
            if (val < 10) return '0' + val
            return val
        },
        handleSelect(v) {
            if(v == "1"){
                this.setUser('用户信息')
            }
            if (v === "2") {
                this.logOut()
            }
        },
        defaultHead(){
            this.btnList[this.$store.state.head.check].hasCheck = true;
            if(this.btnList[0].leaf){
                this.$store.commit('selectMenu', this.btnList[0]);
            }else{
                this.$store.commit('selectMenu', this.btnList[0].children[0]);
            }
        },
    },
    computed: {
        getName() {
            return this.$store.state.head.name
        }
    },
    mounted(){
        this.getUserInfo();
        this.defaultHead();
        let that = this
        this.timer = setInterval(function () {
            that.nowDateTime = that.dateNumber()+" "+that.timeNumber()
        })
    },
    // 销毁时清除计时器
    beforeDestroy: function () {
        if (this.timer) {
            clearInterval(this.timer)
        }
    },
    created(){
        this.decrypt1();
    },
    watch:{
        "$store.state.head.check"() {
            this.btnList.forEach((item) => {
                item.hasCheck = false;
            });
            this.btnList[this.$store.state.head.check].hasCheck = true;
            //localStorage.setItem("check",value)
        },

    }
};
</script>

<style scoped lang="less">
.tb{
  background-color: #2c83ea;
  height: 100%;
}
.menuSt::before{
  content: '';
  position: absolute;
  top: 1px;
  right: 1px;
  bottom: 1px;
  left: 1px;
  z-index: 1;
  /*background-color: rgba(13, 74, 234, 0.76);*/
  /*transform: skew(30deg);*/
}
.menuSt{
  transform: translate(0, -50%);
  top: 50%;
  height: 51px;
  line-height: 51px;
  font-size: 16px;
  color: #fff;
  display: flex;
  /* justify-content: space-around; */
  /* justify-content: flex-start; */
  align-items: center;
  position: relative;
}
.tbdh {
  z-index: 3;
  position: relative;
  color: #fff;
  cursor: pointer;
  margin: 0 1.5rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  background: transparent;
  text-transform: uppercase;
  text-decoration: none;
  display: flex;
  justify-content:center;
  align-items: center;
}
.el-dropdown {
    display: inline-block;
    position: relative;
    color: #fff;
    font-size: 16px;
}
.touxiang {
  margin-right: 1rem;
  width: 4.2rem;
  height: 4.2rem;
}
.btn-container-checked {
  // width: 10rem;
  // height: 10rem;
  // background: #fff;
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  //margin-bottom: -1rem;
  cursor: pointer;
  background: linear-gradient(
          133deg,
            #025bc5 -13%,
            #025bc5 -13%,
          #3dbafd 95%,
          #3dbafd 95%
  );
  box-shadow: 0 0.4rem 1rem rgba(0, 0, 0, 0.3);
  .btn-title {
    color: #fff;
    font-size: 1.4rem;
    display: none;
  }
  .btn-icon {
    height: 3.5rem;
    width: 3.5rem;
    display: none;
  }
  .btn-icon-hover {
    height: 3.5rem;
    width: 3.5rem;
    display: block;
  }
}
/*.el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.header-container{
  display:flex;
  flex-direction: column-reverse;
  height: 100%;
}
.el_row {
  display: flex;

  justify-content: space-between;

  flex-wrap: nowrap;
  width: 100%;
}
.nav {
  width: 80%;
  height: 100%;
  .nav_list {
    width: 100%;
    .nav_item {
      width: 24.8rem;
      height: 5.8rem;
      background: url("../assets/images/nav_bg.png") no-repeat;
      .nav_item_text {
        width: 18.8rem;
        height: 100%;
        font-size: 2rem;
        line-height: 5.8rem;
        text-align: center;
      }
    }
  }
}
.user_info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 15rem;
  cursor: pointer;
  .touxiang {
    margin-right: 1rem;
    width: 4.2rem;
    height: 4.2rem;
  }
  .options {
    position: relative;
    display: flex;
    align-items: center;
    height: 100%;
    .options_text {
      margin-right: 1rem;
    }
    .options_container {
      display: none;
      position: absolute;
      !*bottom: -11rem;*!
      bottom: -7.5rem;
      left: 0;
      width: 100%;
      border-radius: 0.5rem;
      background: #fff;
      box-shadow: 0 0.2rem 0.4rem rgba(170, 170, 170, 0.5);
      overflow: hidden;
      z-index: 9999;
      .options_list {
        width: 100%;
        .options_item {
          display: flex;
          align-items: center;
          width: 100%;
          justify-content: center;
          height: 3.8rem;
          .options_item_icon {
            margin-right: 1rem;
          }
          &:hover {
            background: #24cdfd;
            color: #fff;
          }
        }
      }
    }
    &:hover {
      .options_container {
        display: block;
      }
    }
  }
}*/
</style>
